import gql from 'graphql-tag';

import boxRemoteItemsPageFragment from '../fragments/boxRemoteItemsPageFragment';

export const queryBoxRemoteItemsPage = gql`
  query boxRemoteItemsPage(
    $credentialID: DokkioID!
    $parentFolderRemoteID: String
    $marker: String
  ) {
    boxRemoteItemsPage(
      credentialID: $credentialID
      parentFolderRemoteID: $parentFolderRemoteID
      marker: $marker
    ) {
      ...boxRemoteItemsPageFragment
    }
  }
  ${boxRemoteItemsPageFragment}
`;

export default queryBoxRemoteItemsPage;
